import BaseModelAPI from '../BaseModelAPI';

export default class IncomingDocumentAttachmentDetail extends BaseModelAPI {
	static entity = 'incomingdocumentattachmentdetail';
	static entityName = 'incomingdocumentattachmentdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.incomingDocumentId = '';
			this.incomingDocumentId = {};
			this.fileName = '';
			this.attachmentId = '';
			this.attachment = {};
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}